<template>
    <div class="apprentice-simple-card rubric-answer-show">
        <b-tabs class="apprentice-tab">
            <div v-for="rubric in rubricsIn">
                <b-tab :title="rubric.title">
                    <design-2021-rubric-form-component
                        id="rubric"
                        :rubric-in="rubric"
                        :survey-user-in="surveyUserIn"
                        :form-in="formIn"
                        :multiple="multiple"
                        :edit="edit">
                    </design-2021-rubric-form-component>
                </b-tab>
            </div>
        </b-tabs>
        <b-button
            class="btn-"
            v-if="multiple ? !!multiple.count_left : false"
            variant="primary"
            @click="nextStudent">
            {{ $t('common.next') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-overview-component',
    props: ['formIn', 'rubricsIn', 'surveyUserIn', 'edit', 'multiple'],
    methods: {
        nextStudent() {
            if (!this.multiple || !this.multiple.count_left) {
                window.location.href = this.routes.baseUrl();
            } else {
                window.location.reload();
            }
        },
    },
};
</script>

<style scoped></style>
